import { api } from "../base";

export interface SyncTradesResponse {
  request_id: string;
  status: "ok" | "error";
  headers?: string[];
  rows?: string[][];
  error?: string;
}

const talosBatchBookingEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    syncTradesFromSpreadsheet: build.mutation<SyncTradesResponse, void>({
      query: () => ({
        url: "http://talos-batch-booking.cs-dev.tokyo.pulseprime.systems:5000/ready",
        method: "POST",
      }),
    }),
  }),
});

export const { useSyncTradesFromSpreadsheetMutation } =
  talosBatchBookingEndpoints;
